/**
 * Generated runtime TestId mirror for frontend/src/pages/MyApprovals.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const MyApprovalsTabId = {
  AccessRequests: "access-requests",
  FgRequests: "fg-requests",
  RuleRequests: "rule-requests",
  SodRequests: "sod-requests",
} as const;
export type MyApprovalsTabId = typeof MyApprovalsTabId[keyof typeof MyApprovalsTabId];

export const MyApprovalsTestIds = {
  approvalCard: "approval-card",
  approvalsAccessRequestsPanel: "approvals-access-requests-panel",
  approvalsFgRequestsPanel: "approvals-fg-requests-panel",
  approvalsRuleRequestsPanel: "approvals-rule-requests-panel",
  approvalsSodRequestsPanel: "approvals-sod-requests-panel",
  btnBatchApprove: "btn-batch-approve",
  btnBatchReject: "btn-batch-reject",
  fgApprovalCard: "fg-approval-card",
  myApprovalsPage: "my-approvals-page",
  ruleApprovalCard: "rule-approval-card",
  sodApprovalCard: "sod-approval-card",
  sodRequestsEmptyState: "sod-requests-empty-state",
  tab: (subtype: MyApprovalsTabId) => `tab-${subtype}` as const,
  tabPrefix: () => "tab-" as TestIdPrefix,
  btnApprove: (item_id: string) => `btn-approve-${item_id}`,
  btnApprovePrefix: () => "btn-approve-" as TestIdPrefix,
  btnApproveFg: (item_id: string) => `btn-approve-fg-${item_id}`,
  btnApproveFgPrefix: () => "btn-approve-fg-" as TestIdPrefix,
  btnApproveRule: (request_id: string) => `btn-approve-rule-${request_id}`,
  btnApproveRulePrefix: () => "btn-approve-rule-" as TestIdPrefix,
  btnApproveSod: (request_id: string) => `btn-approve-sod-${request_id}`,
  btnApproveSodPrefix: () => "btn-approve-sod-" as TestIdPrefix,
  btnReject: (item_id: string) => `btn-reject-${item_id}`,
  btnRejectPrefix: () => "btn-reject-" as TestIdPrefix,
  btnRejectFg: (item_id: string) => `btn-reject-fg-${item_id}`,
  btnRejectFgPrefix: () => "btn-reject-fg-" as TestIdPrefix,
  btnRejectRule: (request_id: string) => `btn-reject-rule-${request_id}`,
  btnRejectRulePrefix: () => "btn-reject-rule-" as TestIdPrefix,
  btnRejectSod: (request_id: string) => `btn-reject-sod-${request_id}`,
  btnRejectSodPrefix: () => "btn-reject-sod-" as TestIdPrefix
} as const;
